import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

export const ClassesEmptyState = ({ trainingId }: { trainingId: number }) => {
  const { navigation } = useNavigation()
  return (
    <Box alignItems="center" justifyContent="center" gap="s24" paddingTop="s40">
      <Box alignItems="center" justifyContent="center" gap="s12">
        <Icon.Large icon="people-add" />
        <Box gap="s8" textAlign="center">
          <Text size="200" weight="semibold" color="grey1000">
            {i18n.t('trainings.trainings_revamp.training_detail.groups.empty_state_title')}
          </Text>
          <Text size="200" weight="normal" color="grey800">
            {i18n.t('trainings.trainings_revamp.training_detail.groups.empty_state_description')}
          </Text>
        </Box>
      </Box>
      <Button.Router
        type="secondary"
        onClick={() =>
          track(trackingEvents.training.trainingGroupCreationWizard.goToNewGroupWizard)
        }
        iconName="add"
        to={navigation.trainings.list.details_revamp.view.trainingClasses.tab.newClass.fullPath({
          id: trainingId,
        })}
      >
        {i18n.t('trainings.trainings_revamp.training_detail.new_group_button')}
      </Button.Router>
      {/* <Link.Href external href={''}>
        {i18n.t('trainings.trainings_revamp.training_detail.help_center_link')}
      </Link.Href> */}
    </Box>
  )
}
